import { getJwt } from "./authService";
import http from "./httpService";

const confige = {
  headers: { Authorization: `Bearer ${getJwt()}` },
};

export function register(user) {
  return http.post(`${process.env.REACT_APP_PUBLIC_PATH}users/register`, user);
}

export function editProfile(userData) {
  return http.post(
    `${process.env.REACT_APP_PUBLIC_PATH}users/edit-profile`,
    userData,
    confige
  );
}

export function getUserData() {
  return http.get(
    `${process.env.REACT_APP_PUBLIC_PATH}users/user-data`,
    confige
  );
}

export function getSavedItems() {
  return http.get(
    `${process.env.REACT_APP_PUBLIC_PATH}users/saved-Items`,
    confige
  );
}

export function createView(data) {
  return http.post(
    `${process.env.REACT_APP_PUBLIC_PATH}users/create-view`,
    data,
    confige
  );
}

export function createViewUnauth(data) {
  return http.post(
    `${process.env.REACT_APP_PUBLIC_PATH}users/create-view-unauth`,
    data
  );
}

export function contactUs(data) {
  return http.post(
    `${process.env.REACT_APP_PUBLIC_PATH}users/contact-us`,
    data
  );
}

export function setLastPageUserReaded(data) {
  return http.post(
    `${process.env.REACT_APP_PUBLIC_PATH}users/set-last-page-user-readed`,
    data,
    confige
  );
}

export function setReadingTime(data) {
  return http.post(
    `${process.env.REACT_APP_PUBLIC_PATH}users/set-reading-time`,
    data,
    confige
  );
}

export function createComment(data) {
  return http.post(
    `${process.env.REACT_APP_PUBLIC_PATH}users/create-comment`,
    data,
    confige
  );
}

export function likePost(data) {
  return http.post(
    `${process.env.REACT_APP_PUBLIC_PATH}users/like-post`,
    data,
    confige
  );
}

export function saveArticle(data) {
  return http.post(
    `${process.env.REACT_APP_PUBLIC_PATH}users/save-article`,
    data,
    confige
  );
}

export function saveBook(data) {
  return http.post(
    `${process.env.REACT_APP_PUBLIC_PATH}users/save-book`,
    data,
    confige
  );
}

export function saveQuarterly(data) {
  return http.post(
    `${process.env.REACT_APP_PUBLIC_PATH}users/save-quarterly`,
    data,
    confige
  );
}

export function deleteSavedItem(data) {
  return http.post(
    `${process.env.REACT_APP_PUBLIC_PATH}users/delete-saved-item`,
    data,
    confige
  );
}

export function sendArticleInteresting(data) {
  return http.post(
    `${process.env.REACT_APP_PUBLIC_PATH}users/send-article-interesting`,
    data,
    confige
  );
}

export function getReadingTime() {
  return http.get(
    `${process.env.REACT_APP_PUBLIC_PATH}users/reading-time`,
    confige
  );
}

export function getHalfReadBooks() {
  return http.get(
    `${process.env.REACT_APP_PUBLIC_PATH}users/half-read-books`,
    confige
  );
}

export function getInterests() {
  return http.get(
    `${process.env.REACT_APP_PUBLIC_PATH}users/interests`,
    confige
  );
}

export function createAwaitingPayment(data) {
  return http.post(
    `${process.env.REACT_APP_PUBLIC_PATH}users/create-awaiting-payment`,
    data,
    confige
  );
}

export function updateUser() {
  return http.get(
    `${process.env.REACT_APP_PUBLIC_PATH}users/update-user`,
    confige
  );
}

export function createNewsSubscription(email) {
  return http.post(
    `${process.env.REACT_APP_PUBLIC_PATH}users/news-subscription`,
    email
  );
}

export function onForgetPass(email) {
  return http.post(
    `${process.env.REACT_APP_PUBLIC_PATH}users/reset-password`,
    email
  );
}

export function onChangePass(password, token) {
  return http.post(
    `${process.env.REACT_APP_PUBLIC_PATH}users/reset-password/${token}`,
    password
  );
}
